/**
 * Theme Patches - Kalles 主题补丁集合
 * 用于修复主题本身的 bug，不修改原始主题文件
 */

(function () {
  'use strict';

  /**
   * Patch #1: enableVideoAutoplaying 函数未定义
   * 问题: theme.min.js 调用了 enableVideoAutoplaying() 但该函数未定义
   * 影响: 产品页面视频无法播放，控制台报 ReferenceError
   *
   * iOS 自动播放条件 (全部必须满足):
   *   1. video 必须 muted
   *   2. video 必须有 playsinline 属性
   *   3. video 必须有 autoplay 属性
   *   4. 不依赖用户交互
   */
  window.enableVideoAutoplaying = window.enableVideoAutoplaying || function () {
    var mediaElements = document.querySelectorAll('[data-enable-video-autoplaying="true"][data-deferred-media]');
    mediaElements.forEach(function (el) {
      var template = el.querySelector('template');
      if (template && !el.querySelector('video, iframe')) {
        el.appendChild(template.content.cloneNode(true));
        var video = el.querySelector('video');
        if (video) {
          // iOS 自动播放必备属性
          video.muted = true;
          video.playsInline = true;
          video.autoplay = true;
          video.controls = false;
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');

          // 循环播放
          if (el.getAttribute('data-enable-video-looping') === 'true') {
            video.loop = true;
          }

          // 尝试播放 — iOS 有时需要等 loadeddata 后才能成功
          var playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(function () {
              if (video.readyState >= 2) {
                // 数据已加载（如缓存命中），直接重试
                video.play().catch(function () { });
              } else {
                // 首次播放失败，等数据加载后重试
                video.addEventListener('loadeddata', function onLoaded() {
                  video.removeEventListener('loadeddata', onLoaded);
                  video.play().catch(function () {
                    // 仍然失败则静默，浏览器策略限制
                  });
                });
              }
            });
          }
        }
      }
    });
  };

})();
